import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "education" }
const _hoisted_2 = { class: "column" }
const _hoisted_3 = { class: "column" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Establishment = _resolveComponent("Establishment")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.first_col, (edu, index) => {
        return (_openBlock(), _createBlock(_component_Establishment, {
          key: index,
          class: "establishment",
          edu: edu
        }, null, 8 /* PROPS */, ["edu"]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.second_col, (edu, index) => {
        return (_openBlock(), _createBlock(_component_Establishment, {
          key: index,
          class: "establishment",
          edu: edu
        }, null, 8 /* PROPS */, ["edu"]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}